import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../../services/modal/modal.service';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
@Component({
  selector: 'multi-action',
  moduleId: module.id,
  templateUrl: './multi-action.component.html',
})

/**
 * Multi-Action Modal
 *  This is a multi-action modal that has a title, body and an array of actions.
 *
 *  Example of modalConfig:
 *  const modalConfig = {
 *      type: ModalType.ModalConfig,
 *      title: 'This is a title',
 *      body: 'This is the body of this modal',
 *      actions: [
 *         {
 *              id: 'action1',
 *              text: 'Action 1',
 *              callback: () => {
 *                  this.modalService.deactivate()
 *              }
 *          },
 *          {
 *              id: 'action2',
 *              text: 'Action 2',
 *              callback: () => {
 *                  this.modalService.deactivate()
 *              }
 *          }
 *      ]
 *  }
 *  this.modalService.activate(modalConfig);
 */
export class MultiActionModalComponent {
  data;
  userResponse: any = {};

  constructor(private amorphicService: AmorphicService, private modalService: ModalService, private router: Router) {}

  handle(index: number) {
    const action = this.data.actions[index];
    if (action && action.callback) {
      action.callback(this.amorphicService, this.modalService, this.router);
    }
  }
}
